export default __webpack_public_path__ + "static/media/general_notify_icon.08ef5660.svg";